import React from 'react'
import SectionHeader from '../components/SectionHeader'
// import FilmCard from '../components/cards/FilmCard'
// import jokerPoster from '../assets/img/jokerPoster.webp'
import CentersSelect from '../components/films/CentersSelect'
// import { useTranslation } from 'react-i18next';

const FilmsPage = () => {
  // const { t } = useTranslation();
  return (
    <section className='pt-[60px] pb-[32px]'>
    <SectionHeader title='Seanslar'/>
    <CentersSelect/>
    </section>
  )
}

export default FilmsPage